import { render } from "./RemoveJob.vue?vue&type=template&id=1de35a4d&scoped=true"
import script from "./RemoveJob.vue?vue&type=script&lang=js"
export * from "./RemoveJob.vue?vue&type=script&lang=js"

import "./RemoveJob.vue?vue&type=style&index=0&id=1de35a4d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de35a4d"]])

export default __exports__